/* Bubble menu config (Phase 5e §2.3).
 *
 * Returns options for `BubbleMenu.configure()`. Hides the menu when:
 *   - There's no text selection (cursor only)
 *   - The selection is inside the title node
 *   - The selection is inside a code block
 */
export function configureBubbleMenu(menuEl) {
  return {
    element: menuEl,
    tippyOptions: { duration: 100, placement: 'top' },
    shouldShow: ({ editor, from, to }) => {
      if (from === to) return false;
      const $from = editor.state.doc.resolve(from);
      if ($from.parent.type.name === 'title') return false;
      if ($from.parent.type.name === 'codeBlock') return false;
      return true;
    },
  };
}
